import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Pricing from "./pages/Pricing";
import BillingSuccess from "./pages/BillingSuccess";
import Account from "./pages/Account";
import CandidateDashboard from "./pages/CandidateDashboard";
import EmployerDashboard from "./pages/EmployerDashboard";
import FlexDashboard from "./pages/FlexDashboard";
import Marketplace from "./pages/Marketplace";
import HealthMarketplace from "./pages/HealthMarketplace";
import JobsBoard from "./pages/JobsBoard";
import ManageAlerts from "./pages/ManageAlerts";
import Admin from "./pages/Admin";
import "./App.css";

function Protected({ role, children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-10 font-mono2 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (role && user.role !== role)
    return <Navigate to={user.role === "employer" ? "/employer" : user.role === "admin" ? "/admin" : user.role === "flex" ? "/flex" : "/candidate"} replace />;
  return children;
}

function Shell() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/jobs" element={<JobsBoard />} />
        <Route path="/jobs/:id" element={<JobsBoard />} />
        <Route path="/alerts/manage/:token" element={<ManageAlerts />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/billing/success" element={<BillingSuccess />} />
        <Route
          path="/account"
          element={
            <Protected>
              <Account />
            </Protected>
          }
        />
        <Route
          path="/candidate"
          element={
            <Protected role="candidate">
              <CandidateDashboard />
            </Protected>
          }
        />
        <Route
          path="/employer"
          element={
            <Protected role="employer">
              <EmployerDashboard />
            </Protected>
          }
        />
        <Route
          path="/flex"
          element={
            <Protected role="flex">
              <FlexDashboard />
            </Protected>
          }
        />
        <Route path="/marketplace/onsite" element={<Marketplace mode="onsite" />} />
        <Route path="/marketplace/remote" element={<Marketplace mode="remote" />} />
        <Route path="/marketplace/health" element={<HealthMarketplace />} />
        <Route
          path="/admin"
          element={
            <Protected role="admin">
              <Admin />
            </Protected>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
